import { DEFAULT_LANGUAGE } from 'APP/constants/language';
import { storage } from 'APP/packages/storage';

export function getLanguage(): string {
  return storage.language.get() || window.navigator.language || DEFAULT_LANGUAGE;
}
